// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/mcp.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.settings.v1.MCPSettingsRef
 */
export interface MCPSettingsRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.MCPServer
 */
export interface MCPServer {
    /**
     * @generated from protobuf field: string url = 1;
     */
    url: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool enabled = 3;
     */
    enabled: boolean;
}
/**
 * @generated from protobuf message c1.api.settings.v1.CreateMCPSettingsRequest
 */
export interface CreateMCPSettingsRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.MCPServer server = 1;
     */
    server?: MCPServer;
}
/**
 * @generated from protobuf message c1.api.settings.v1.CreateMCPSettingsResponse
 */
export interface CreateMCPSettingsResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.settings.v1.MCPServer server = 2;
     */
    server?: MCPServer;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.ListMCPSettingsRequest
 */
export interface ListMCPSettingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.MCPSettings
 */
export interface MCPSettings {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.settings.v1.MCPServer server = 2;
     */
    server?: MCPServer;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.ListMCPSettingsResponse
 */
export interface ListMCPSettingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.settings.v1.MCPSettings list = 1;
     */
    list: MCPSettings[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetMCPSettingsRequest
 */
export interface GetMCPSettingsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetMCPSettingsResponse
 */
export interface GetMCPSettingsResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.settings.v1.MCPServer server = 2;
     */
    server?: MCPServer;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateMCPSettingsRequest
 */
export interface UpdateMCPSettingsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.settings.v1.MCPServer server = 2;
     */
    server?: MCPServer;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateMCPSettingsResponse
 */
export interface UpdateMCPSettingsResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.settings.v1.MCPServer server = 2;
     */
    server?: MCPServer;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.DeleteMCPSettingsRequest
 */
export interface DeleteMCPSettingsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.DeleteMCPSettingsResponse
 */
export interface DeleteMCPSettingsResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SearchMCPSettingsRequest
 */
export interface SearchMCPSettingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.settings.v1.MCPSettingsRef refs = 3;
     */
    refs: MCPSettingsRef[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.SearchMCPSettingsResponse
 */
export interface SearchMCPSettingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.settings.v1.MCPSettings list = 1;
     */
    list: MCPSettings[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.ListToolsMCPServiceRequest
 */
export interface ListToolsMCPServiceRequest {
    /**
     * @generated from protobuf field: string server_id = 1;
     */
    serverId: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.MCPTool
 */
export interface MCPTool {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.ListToolsMCPServiceResponse
 */
export interface ListToolsMCPServiceResponse {
    /**
     * @generated from protobuf field: repeated c1.api.settings.v1.MCPTool tools = 1;
     */
    tools: MCPTool[];
}
// @generated message type with reflection information, may provide speed optimized methods
class MCPSettingsRef$Type extends MessageType<MCPSettingsRef> {
    constructor() {
        super("c1.api.settings.v1.MCPSettingsRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.MCPSettingsRef
 */
export const MCPSettingsRef = new MCPSettingsRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MCPServer$Type extends MessageType<MCPServer> {
    constructor() {
        super("c1.api.settings.v1.MCPServer", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.MCPServer
 */
export const MCPServer = new MCPServer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateMCPSettingsRequest$Type extends MessageType<CreateMCPSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.CreateMCPSettingsRequest", [
            { no: 1, name: "server", kind: "message", T: () => MCPServer, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.CreateMCPSettingsRequest
 */
export const CreateMCPSettingsRequest = new CreateMCPSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateMCPSettingsResponse$Type extends MessageType<CreateMCPSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.CreateMCPSettingsResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "server", kind: "message", T: () => MCPServer },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.CreateMCPSettingsResponse
 */
export const CreateMCPSettingsResponse = new CreateMCPSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMCPSettingsRequest$Type extends MessageType<ListMCPSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.ListMCPSettingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.ListMCPSettingsRequest
 */
export const ListMCPSettingsRequest = new ListMCPSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MCPSettings$Type extends MessageType<MCPSettings> {
    constructor() {
        super("c1.api.settings.v1.MCPSettings", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "server", kind: "message", T: () => MCPServer },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.MCPSettings
 */
export const MCPSettings = new MCPSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMCPSettingsResponse$Type extends MessageType<ListMCPSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.ListMCPSettingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MCPSettings },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.ListMCPSettingsResponse
 */
export const ListMCPSettingsResponse = new ListMCPSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMCPSettingsRequest$Type extends MessageType<GetMCPSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.GetMCPSettingsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetMCPSettingsRequest
 */
export const GetMCPSettingsRequest = new GetMCPSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMCPSettingsResponse$Type extends MessageType<GetMCPSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.GetMCPSettingsResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "server", kind: "message", T: () => MCPServer },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetMCPSettingsResponse
 */
export const GetMCPSettingsResponse = new GetMCPSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMCPSettingsRequest$Type extends MessageType<UpdateMCPSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateMCPSettingsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "server", kind: "message", T: () => MCPServer }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateMCPSettingsRequest
 */
export const UpdateMCPSettingsRequest = new UpdateMCPSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMCPSettingsResponse$Type extends MessageType<UpdateMCPSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateMCPSettingsResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "server", kind: "message", T: () => MCPServer },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateMCPSettingsResponse
 */
export const UpdateMCPSettingsResponse = new UpdateMCPSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMCPSettingsRequest$Type extends MessageType<DeleteMCPSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.DeleteMCPSettingsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.DeleteMCPSettingsRequest
 */
export const DeleteMCPSettingsRequest = new DeleteMCPSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMCPSettingsResponse$Type extends MessageType<DeleteMCPSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.DeleteMCPSettingsResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.DeleteMCPSettingsResponse
 */
export const DeleteMCPSettingsResponse = new DeleteMCPSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMCPSettingsRequest$Type extends MessageType<SearchMCPSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.SearchMCPSettingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MCPSettingsRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SearchMCPSettingsRequest
 */
export const SearchMCPSettingsRequest = new SearchMCPSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMCPSettingsResponse$Type extends MessageType<SearchMCPSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.SearchMCPSettingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MCPSettings },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SearchMCPSettingsResponse
 */
export const SearchMCPSettingsResponse = new SearchMCPSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListToolsMCPServiceRequest$Type extends MessageType<ListToolsMCPServiceRequest> {
    constructor() {
        super("c1.api.settings.v1.ListToolsMCPServiceRequest", [
            { no: 1, name: "server_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.ListToolsMCPServiceRequest
 */
export const ListToolsMCPServiceRequest = new ListToolsMCPServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MCPTool$Type extends MessageType<MCPTool> {
    constructor() {
        super("c1.api.settings.v1.MCPTool", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.MCPTool
 */
export const MCPTool = new MCPTool$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListToolsMCPServiceResponse$Type extends MessageType<ListToolsMCPServiceResponse> {
    constructor() {
        super("c1.api.settings.v1.ListToolsMCPServiceResponse", [
            { no: 1, name: "tools", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MCPTool }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.ListToolsMCPServiceResponse
 */
export const ListToolsMCPServiceResponse = new ListToolsMCPServiceResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.MCPSettingsService
 */
export const MCPSettingsService = new ServiceType("c1.api.settings.v1.MCPSettingsService", [
    { name: "Create", options: { "authz.method": { role: "OWNER" } }, I: CreateMCPSettingsRequest, O: CreateMCPSettingsResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListMCPSettingsRequest, O: ListMCPSettingsResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetMCPSettingsRequest, O: GetMCPSettingsResponse },
    { name: "Update", options: { "authz.method": { role: "OWNER" } }, I: UpdateMCPSettingsRequest, O: UpdateMCPSettingsResponse },
    { name: "Delete", options: { "authz.method": { role: "OWNER" } }, I: DeleteMCPSettingsRequest, O: DeleteMCPSettingsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.MCPSettingsSearchService
 */
export const MCPSettingsSearchService = new ServiceType("c1.api.settings.v1.MCPSettingsSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchMCPSettingsRequest, O: SearchMCPSettingsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.MCPService
 */
export const MCPService = new ServiceType("c1.api.settings.v1.MCPService", [
    { name: "ListTools", options: { "authz.method": { role: "VIEWER" } }, I: ListToolsMCPServiceRequest, O: ListToolsMCPServiceResponse }
]);
